// import api from './fetchApi'
import chain from '@/lib/axios-chain'

// 根据角色获取人员列表相关接口
// 获取团队组织结构列表
export const getTeamOrganization = () =>
  chain.create('/user/team/teamgrouptreeinfo', 'get')
// 获取项目下人员列表
export const getProjectMembers = () =>
  chain.create('/user/team/memberlist', 'get')
// 获取团队下人员列表
export const getTeamMembers = () =>
  chain.create('/user/team/teammembers', 'get')
// 获取小组下人员列表
export const getGroupMembers = () =>
  chain.create('/user/team/groupdetail', 'get')
// 获取搜索人员
export const getSearchUsersDatas = () =>
  chain.create('/user/team/searchauthuserinfo', 'get')
// 获取团队设置头部信息
export const getTeamSetLeaderDatas = () =>
  chain.create('/user/team/setteam', 'post')
// 获取团队设置权限列表
export const getTeamSetPermissionList = () =>
  chain.create('/user/permission/team-config', 'get')
// 保存团队设置权限列表
export const saveTeamSetPermissionList = () =>
  chain.create('/user/permission/team-update', 'post')

// 成员相关接口
// 添加成员待选成员列表
export const getAddmemberList = () =>
  chain.create('/user/team/addmemberlist', 'get')
// 获取用户详情
export const getMemberDetail = () =>
  chain.create('/user/team/memberdetail', 'get')
// 删除成员
export const deleteMember = () => chain.create('/user/team/delmember', 'post')
// 编辑成员信息
export const editMemberInfo = () =>
  chain.create('/user/team/editmember', 'post')
// 邀请新成员
export const inviteNewMember = () =>
  chain.create('/user/invite/sendinviteusers', 'post')
// 邀请新成员---判断邮箱是都注册过
export const emailIsRegister = () =>
  chain.create('/user/invite/emailisreg', 'post')
// 获取项目角色
export const getRoles = () => chain.create('/user/invite/getroles', 'get')
// 通过角色获取组
export const getGroups = () => chain.create('/user/invite/getgroups', 'get')
// 通过角色获取组--成员管理
export const getGroups2 = () => chain.create('/user/invite/getgroups2', 'get')
// 向项目中添加成员保存接口
export const saveAddMember = () => chain.create('/user/team/addmember', 'post')

// 小组相关接口
// 添加小组--保存接口
export const saveAddGroup = () => chain.create('/user/team/addgroup', 'post')
// 添加小组--获取可添加人员方法
export const getEnableMembers = () =>
  chain.create('/user/team/getsameroleusers', 'get')
// 删除小组
export const deleteGroup = () => chain.create('/user/team/delgroup', 'post')
// 编辑小组
export const editGroup = () => chain.create('/user/team/editgroup', 'post')
// 获取小组设置权限列表
export const getGroupSetPermissionDatas = () =>
  chain.create('/user/permission/group-config', 'get')
// 获取小组设置权限列表提交
export const saveGroupSetPermissionDatas = () =>
  chain.create('/user/permission/group-update', 'post')
// 小组组长设置编辑提交
export const saveGroupLeader = () => chain.create('/user/team/setgroup', 'post')
// 判断邀请是否有效
export const inviteIsVold = () =>
  chain.create('/user/invite/openinviteurl', 'get')

// 判断邀请是否有效
export const loginOrRegisterInvite = () =>
  chain.create('/user/invite/regorlogin', 'post')
// 完善用户信息
export const supplyUsersInfoInvite = () =>
  chain.create('/user/invite/supply', 'post')
// 完善用户信息
export const joinOrgInfo = () =>
  chain.create('/user/invite/acceptinvite', 'post')
  // 完善用户信息
export const getAddStructureList = () =>
  chain.create('/user/team/addstructurelist', 'get')
